import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection.js';
import SubMenuTabs from '../common/subMenuTabs/SubMenuTabs.js';
import SelectEconomic from '../common/select-filters/SelectEconomic.js';
import SectorSelector from '../common/select-filters/SectorSelector.js';
import DatasetSelectTrend from '../common/select-filters/DatasetSelectTrend.js';
import HealthPerceptionChart from '../common/charts/HealthPerceptionChart.js';
import Methodology from '../common/Methodology.js';

import { reportedHealthProblemsTabs } from '../../model/subMenuTabs.js';

import { setCountry1 } from '../../actions';

const ReportedHealthProblems = props => {

    const currentPath = '/accidents-diseases-well-being/data-on-workers-health/reported-health-problems/';

    const { selectCountry, selectCountry2, selectCountry3, selectedByUser, lockedCountry } = useSelector((state) => state.selectCountries);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedTab, setSelectedTab] = useState('');
    const [selectedDataset1, setSelectedDataset1] = useState('');
    const [selectedDataset2, setSelectedDataset2] = useState('');
    const [sector1, setSector1] = useState(null);
    const [sector2, setSector2] = useState(null);
    const [sector3, setSector3] = useState(null);
        
    // Hook for the dispatchs
    const dispatch = useDispatch();

    useEffect(() => {
        // Update the title of the page
		document.title = props.literals.L20928 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

        let selected = reportedHealthProblemsTabs.find((tab) => tab.url == props.category);

        if ( selected != null )
        {
            setSelectedTab(selected);
            setIsLoading(false);
        }
    }, []);

    const callbackSelectedCategory = (category) => {
        const newTab = reportedHealthProblemsTabs.find((tab) => tab.url == category);

        if (newTab != null)
        {
            setSelectedTab(newTab);
        }
    }

    const callbackSelectedSurvey = (survey) => {

    }

    const handleSearch = (callbackCountry1) =>{
        if (selectedByUser) {
            setCountryLocked(callbackCountry1)
        } else {
            dispatch(setCountry1(callbackCountry1))
        }
    }

    const handleDatasetChange1 = (dataset) => {
        setSelectedDataset1(dataset);
	}

    const handleDatasetChange2 = (dataset) => {
        setSelectedDataset2(dataset);
	}

    const handleSector1Change = (callbackSector1) => {
        setSector1(callbackSector1);
	}

	const handleSector2Change = (callbackSector2) => {
        setSector2(callbackSector2);
	}

	const handleSector3Change = (callbackSector3) => {
        setSector3(callbackSector3);
	}


    if (!isLoading)
    {
        const currentChart = selectedTab.chartType[0];

        let sectorSelect = null;
        let countrySelect = null;
        if ( selectedTab.showSectorSelect )
        {
            sectorSelect = <>
                    <SectorSelector 
                        indicator={ currentChart.chartIndicator }
                        literals={ props.literals }
                        handleSector1Change = { handleSector1Change }
                        handleSector2Change = { handleSector2Change }
                        handleSector3Change = { handleSector3Change }
                    />
                
                    <div className="line background-main-light" />
                </>
        }

        if ( selectedTab.showCountrySelect )
        {
            countrySelect = <>
                    <SelectEconomic 
                        handleSearch= { handleSearch } 
                        charts= { [ currentChart.chart ] }
                        indicator= { currentChart.chartIndicator }
                        literals= { props.literals }
                        selectedCountry1= { selectedByUser ? lockedCountry : selectCountry }
                        selectedCountry2= { selectCountry2 }
                        selectedCountry3= { selectCountry3 }
                        selectOneCountry= { true }
                    />

                    <div className="line background-main-light" />
                </>
        }

        return(
            <div className="reported-health-problems">
                <AdviceSection literals={ props.literals } section={["accidents-diseases-well-being","reported-health-problems"]} methodologyData={{section: 'accidents-diseases-well-being', subsection: 'Health problems caused or made worse by work', indicator: 582 } } />
                
                <SubMenuTabs
                    literals={ props.literals }
                    selectedTab={ selectedTab.url }
                    callbackSelectedTab={ callbackSelectedCategory }
                    locationPath={ currentPath }
                    subMenuTabs={ reportedHealthProblemsTabs } 
                />
                <div className="line background-main-light" />
            
                { sectorSelect }
                { countrySelect }
                
                <DatasetSelectTrend
                    literals={ props.literals }
                    chartType={ selectedTab.chartType }
                    callbackSelectedSurvey={ callbackSelectedSurvey }
                    handleDatasetChange1={ handleDatasetChange1 }
                    handleDatasetChange2={ (e) => handleDatasetChange2(e) }
                    showSourceSelect={ false }
                    showAnswerSelect={ false }
                    selectedIndicator={ selectedTab.chartType[0].chartIndicator }
                    chartSplit = { selectedTab.chartType[0].split }
                    yearOnly={ false }
                />
                <div className="line background-main-light" />

                <div class="container section--page card--grid xxs-w1 xs-w1 w1 center-text">
                    <div class="card--block--chart">
                        <HealthPerceptionChart 
                            title={ props.literals[`L${currentChart.title}`] }
                            indicator= { currentChart.chartIndicator }
                            chart = { currentChart.chart }
                            colors={ ['#f6a400','#cbe2e3','#7b7b7d','#ffe300','#449fa2','#f3c564','#16983e'] }
                            dataset={ selectedDataset1 }
                            sector1={ sector1 }
                            sector2={ sector2 }
                            sector3={ sector3 }
                            country = { selectedByUser ? lockedCountry : selectCountry }
                            filterByCountry = { selectedTab.showCountrySelect }
                        />
                    </div>
                    <div className="chart-legend">
                        { ReactHtmlParser( props.literals[`L${ selectedTab.chartType[0].legend }`] ) }
                    </div>
                </div>

                <Methodology literals={ props.literals } section={'Health problems caused or made worse by work'} indicator={ currentChart.chartIndicator } />
            </div>
        )
    }
    else
    {
        return null;
    }
}

ReportedHealthProblems.displayName = 'ReportedHealthProblems';
export default ReportedHealthProblems;